export default "__VITE_ASSET__D$bVfm1W__"